import client from "../client";

export async function getEvMasterData() {
	try {
		const res = await client("/v1/masterData", {
			method: "GET",
			version: "evCharging",
		});
		return res;
	} catch (error) {
		console.error(error);
		throw error;
	}
}

export async function getCpoProviders(queryParams: string) {
	try {
		const res = await client(`/v1/evCpoProvider${queryParams}`, {
			method: "GET",
			version: "evCharging",
		});
		return res;
	} catch (error) {
		console.error(error);
		throw error;
	}
}

export async function createCpoProvider(name: string) {
	try {
		const res = await client("/v1/evCpoProvider", {
			method: "POST",
			version: "evCharging",
			data: { name },
		});
		return res;
	} catch (error) {
		console.error(error);
		throw error;
	}
}

export async function updateCpoProvider(id: string, name: string) {
	try {
		const res = await client("/v1/evCpoProvider", {
			method: "PUT",
			version: "evCharging",
			data: { id, name },
		});
		return res;
	} catch (error) {
		console.error(error);
		throw error;
	}
}

export async function updateCpoProviderStatus(id: number, status: number) {
	try {
		const res = await client("/v1/evCpoProvider/status", {
			method: "PUT",
			version: "evCharging",
			data: { id, status },
		});
		return res;
	} catch (error) {
		console.error(error);
		throw error;
	}
}
